const weekDays = [
    { value: 'Monday', label: 'Monday', status: 1 },
    { value: 'Tuesday', label: 'Tuesday', status: 1 },
    { value: 'Wednesday', label: 'Wednesday', status: 1 },
    { value: 'Thursday', label: 'Thursday', status: 1 },
    { value: 'Friday', label: 'Friday', status: 1 },
    { value: 'Saturday', label: 'Saturday', status: 0 },
    { value: 'Sunday', label: 'Sunday', status: 0 },
];

export default weekDays;
